import { buildProps, definePropType, isArray } from '@zoryn/utils'
import { datePickTypes } from '@zoryn/constants'

import type { ExtractPropTypes, ExtractPublicPropTypes } from 'vue'
import type { Dayjs } from 'dayjs'
import type { DatePickType } from '@zoryn/constants'
import type { DayOrDays } from '@zoryn/components/time-picker'

const selectionModes = [
  'date',
  'dates',
  'year',
  'years',
  'month',
  'months',
  'week',
  'range',
]

export type RangeState = {
  endDate: null | Dayjs
  selecting: boolean
}

export type DisabledDateType = (date: Date) => boolean
export type CellClassNameType = (date: Date) => string

export const datePickerSharedProps = buildProps({
  cellClassName: {
    type: definePropType<CellClassNameType>(Function),
  },
  disabledDate: {
    type: definePropType<DisabledDateType>(Function),
  },
  date: {
    type: definePropType<Dayjs>(Object),
    required: true,
  },
  minDate: {
    type: definePropType<Dayjs | null>(Object),
  },
  maxDate: {
    type: definePropType<Dayjs | null>(Object),
  },
  parsedValue: {
    type: definePropType<Dayjs | Dayjs[]>([Object, Array]),
  },
  rangeState: {
    type: definePropType<RangeState>(Object),
    default: () => ({
      endDate: null,
      selecting: false,
    }),
  },
  disabled: Boolean,
} as const)

export const panelSharedProps = buildProps({
  type: {
    type: definePropType<DatePickType>(String),
    required: true,
    values: datePickTypes,
  },
  dateFormat: String,
  timeFormat: String,
  showNow: {
    type: Boolean,
    default: true,
  },
  showConfirm: Boolean,
  showFooter: {
    type: Boolean,
    default: true,
  },
  showWeekNumber: Boolean,
  border: Boolean,
  disabled: Boolean,
  editable: {
    type: Boolean,
    default: true,
  },
} as const)

export const panelRangeSharedProps = buildProps({
  unlinkPanels: Boolean,
  visible: {
    type: Boolean,
    default: true,
  },
  showConfirm: Boolean,
  showFooter: {
    type: Boolean,
    default: true,
  },
  border: Boolean,
  disabled: Boolean,
  parsedValue: {
    type: definePropType<DayOrDays>(Array),
  },
  singlePanel: Boolean,
} as const)

export const selectionModeWithDefault = (
  mode: (typeof selectionModes)[number]
) => {
  return {
    type: String,
    values: selectionModes,
    default: mode,
  }
}

export const rangePickerSharedEmits = {
  pick: (range: [Dayjs, Dayjs]) => isArray(range),
}

export type RangePickerSharedEmits = typeof rangePickerSharedEmits
export type PanelRangeSharedProps = ExtractPropTypes<
  typeof panelRangeSharedProps
>
export type PanelRangeSharedPropsPublic = ExtractPublicPropTypes<
  typeof panelRangeSharedProps
>
